<ul>
    <li *ngFor="let item of stepItems; index as i" class="mb-15">
        <div style="display: flex;">
            <!-- 图标 -->
            <div class="steps-icon-box">
                <svg *ngIf="!item.stepFinished && i !== activeStep" class="steps-icon">
                    <use xlink:href="#app-icon-smart-assistant-unactive"></use>
                </svg>
                <svg *ngIf="i === activeStep" class="steps-icon">
                    <use xlink:href="#app-icon-smart-assistant-active"></use>
                </svg>
                <svg *ngIf="item.stepFinished" class="steps-icon">
                    <use xlink:href="#app-icon-smart-assistant-success"></use>
                </svg>
                <div *ngIf="!item.stepFinished" class="steps-icon-number">{{i + 1}}</div>
                <!-- icon连接线 -->
                <svg class="steps-icon-line" *ngIf="i < stepItems.length - 1">
                    <line x1="0" x2="0" y1="0" y2="160"
                        style="stroke-width: 2;"
                        stroke-dasharray="4, 4"
                        stroke="#cccccc">
                    </line>
                </svg>
            </div>
            <!-- 操作和数据展示 -->
            <div class="operate-box" style="display: flex;" [ngStyle]="item.style">
                <div style="display: flex;">
                    <!-- 图标 -->
                    <svg class="operate-box-icon">
                        <use [attr.xlink:href]="item.icon"></use>
                    </svg>
                    <div>
                        <!-- title -->
                        <div nTextTips style="max-width: 1.55rem;">
                            <span>{{item.label}}</span>
                        </div>
                        <!-- 已创建对象 -->
                        <div *ngIf="item.info" class="sub operate-box-obj-info"
                            [id]="'guidance-steps-' + i + '-item-info'">
                            <span>{{item.info}}</span>
                        </div>
                        <ng-container *ngIf="item.info">
                            <ul class="operate-box-obj-list">
                                <li *ngFor="let obj of item.objList; index as j" nTextTips
                                    trigger="click"
                                    [id]="'guidance-steps-' + i + '-item-info-obj-' + j">
                                    <span>{{j + 1}}. </span>
                                    <span>{{obj}}</span>
                                </li>
                            </ul>
                            <!-- 超过3条显示省略号（只有LUN显示） -->
                            <span *ngIf="item.objCount > MAX_DISPLAY_COUNT && item.objType === GuideCreateOptions.CreateLun"
                                class="operate-box-obj-ellipsis">
                                {{'...'}}
                            </span>
                        </ng-container>
                        <div *ngIf="item.objDeletedTip" [id]="'guidance-steps-' + i + '-item-deleted-tip'"
                            class="sub operate-box-obj-delete-info">
                            <span>{{item.objDeletedTip}}</span>
                        </div>
                    </div>
                </div>
                <!-- 开始按钮-只有创建LUN才显示 -->
                <button *ngIf="i === GuideCreateOptions.CreateLun && activeStep === GuideCreateOptions.CreateLun && showStartBtn"
                    id="guidance-steps-start-btn" nButton [label]="i18n.startBtn" theme="primary" (click)="startGuiding()">
                </button>
                <!-- Primary按钮 -->
                <button *ngIf="item.showInitialBtn" [id]="'guidance-steps-' + i + '-initial-btn'"
                    [label]="item.initialBtnLabel" nButton theme="primary" (click)="doStepGuide(i)">
                </button>
                <!-- CreateMore按钮 -->
                <button nButton *ngIf="item.info && !item.hideMorebtn" [label]="item.btnLabel"
                    [nTooltip]="item.btnTooltip" class="operate-box-create-more-btn"
                    [id]="'guidance-steps-create-more-' + i + '-btn'"
                    theme="text" nTextTips (click)="jumpToPage(i)">
                </button>
            </div>
        </div>
    </li>
</ul>
